export const EMOTIONS = [
  { key: "joyful", label: "Joyful", emoji: "😄", color: "#F2B84B" },
  { key: "calm", label: "Calm", emoji: "😌", color: "#6FAF9E" },
  { key: "grateful", label: "Grateful", emoji: "🙏", color: "#E8836B" },
  { key: "hopeful", label: "Hopeful", emoji: "🌱", color: "#7FA9D1" },
  { key: "tired", label: "Tired", emoji: "😴", color: "#A79CC2" },
  { key: "anxious", label: "Anxious", emoji: "😟", color: "#D9A05B" },
  { key: "sad", label: "Sad", emoji: "😢", color: "#7C90B0" },
  { key: "angry", label: "Angry", emoji: "😠", color: "#C1584A" },
  { key: "lonely", label: "Lonely", emoji: "🫥", color: "#8C7EA8" },
  { key: "stressed", label: "Stressed", emoji: "😣", color: "#B08A5A" },
];

export const EMOTION_MAP = Object.fromEntries(EMOTIONS.map((e) => [e.key, e]));
